import { withBreakpointObserver } from '@studiometa/js-toolkit';
import { Draggable, Modal } from '@studiometa/ui';

/**
 * @typedef {{}} ZoomedGalleryProps
 */

/**
 * ZoomedGallery ZoomedGallery.
 * @augments {Base<ZoomedGalleryProps>}
 */
export default class ZoomedGallery extends withBreakpointObserver(Modal) {
  isOpen = false;
  imagesAreDisplayed = false;
  zoom = 0;
  index = 0;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'ZoomedGallery',
    components: {
      Draggable,
    },
    options: {
      inactiveBreakpoints: {
          type: String,
          default: 'xxs xs s m',
      },
    },
    refs: ['close', 'img[]', 'plus', 'minus', 'counter', 'thumbs[]', 'wrapper', 'prev', 'next'],
  };

  /**
   *
   */
  mounted() {
    this.currentImage = this.$refs.img[0];
    this.currentThumb = this.$refs.thumbs[0];
    this.zoomedGallery = this.$children.Draggable[0].$refs.target;
  }

  /**
   *
   */
  onPrevClick() {
    if (this.index === 0) {
      return;
    }

    this.index -= 1;
    this.setCurrentThumbs();
  }

  /**
   *
   */
  onNextClick() {
    if (this.index === this.$refs.img.length - 1) {
      return;
    }

    this.index += 1;
    this.setCurrentThumbs();
  }

  /**
   *
   */
  onCloseClick() {
    this.closeGallery();
  }

  /**
   *
   * @param {number} index index of element to be scrolled
   */
  openGallery(index) {
    // this.header.classList.add('tw--translate-y-full');
    this.isOpen = true;
    this.index = index;

    this.setCurrentThumbs();

    document.body.classList.add('tw-overflow-hidden');
    this.$el.classList.remove('tw-opacity-0', 'tw-pointer-events-none');
  }

  /**
   * OnThumbsClick
   * @param {object} props
   * @param {number} props.index
   */
  onThumbsClick({ index }) {
    this.index = index;
    this.setCurrentThumbs();
    this.setZoomLevel();
  }

  /**
   * Set current state for elements
   */
  setCurrentThumbs() {
    this.currentThumb.classList.add('tw-opacity-50');
    this.currentThumb = this.$refs.thumbs[this.index];
    this.currentThumb.classList.remove('tw-opacity-50');

    this.currentImage.classList.add('tw-hidden');
    this.currentImage = this.$refs.img[this.index];
    this.currentImage.classList.remove('tw-hidden');

    this.setNavState();
  }

  /**
   *
   */
  setNavState() {
    if (this.index === 0) {
      this.$refs.prev.classList.add('tw-opacity-20', 'tw-pointer-events-none');
    } else {
      this.$refs.prev.classList.remove('tw-opacity-20', 'tw-pointer-events-none');
    }

    if (this.index === this.$refs.img.length - 1) {
      this.$refs.next.classList.add('tw-opacity-20', 'tw-pointer-events-none');
    } else {
      this.$refs.next.classList.remove('tw-opacity-20', 'tw-pointer-events-none');
    }
  }

  /**
   *
   */
  onPlusClick() {
    if (this.zoom === 2) {
      return;
    }
    this.zoomedGallery.classList.remove('tw-pointer-events-none');

    this.zoom += 1;
    this.setZoomLevel();
  }

  /**
   *
   */
  onMinusClick() {
    if (this.zoom === 0) {
      return;
    }

    if (this.zoom === 1) {
      this.zoomedGallery.style.transform = `translate3d(0, 0, 0)`;
      this.zoomedGallery.classList.add('tw-pointer-events-none');
    }

    this.zoom -= 1;
    this.setZoomLevel();
  }

  /**
   *
   */
  setZoomLevel() {
    const percent = this.zoom * 50;
    const scale = 1 + this.zoom * 0.6;
    this.$refs.counter.textContent = percent;
    this.$refs.wrapper.style.transform = `scale(${scale})`;
  }

  /**
   *
   */
  closeGallery() {
    this.isOpen = false;
    document.body.classList.remove('tw-overflow-hidden');
    this.$el.classList.add('tw-opacity-0', 'tw-pointer-events-none');
    // this.header.classList.remove('tw--translate-y-full');
  }

  /**
   * Close panel when type on Escape key
   * @param {object} props Props
   * @param {object} props.ESC Escape key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeGallery();
    }
  }
}
